import React, { useState } from 'react';
import { FieldError } from 'react-hook-form';
import { useLazyTermItemsQuery } from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import MultiSelectWithCheckList from '../MultiSelectWithCheckList/MultiSelectWithCheckList';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import Loading from '../../../../../Components/Loading';

interface Props {
	onChange?: (value: SelectValue[]) => void;
	value?: SelectValue[];
	error?: FieldError;
	placeholder?: string;
	portal?: boolean;
}

const InsuranceCompaniesMultiSelectWithCheckList: React.FC<Props> = ({
	value,
	onChange,
	placeholder,
	portal,
}) => {
	const [isReady, setIsReady] = useState(false);
	const [options, setOptions] = useState<SelectValue[]>([]);
	const [getTermItems] = useLazyTermItemsQuery();

	useEffectAsync(async () => {
		const items: SelectValue[] = [];

		const { termItems } = await getTermItems({
			termType: 'insurance_companies',
			take: 999,
		}).unwrap();

		for (const termItem of termItems?.data || []) {
			if (termItem) {
				items.push({
					value: termItem.id,
					label: `${termItem.value} - ${termItem.value2}`,
				});
			}
		}

		setOptions(items);
		setIsReady(true);
	}, []);

	if (!isReady) {
		return <Loading />;
	}

	return (
		<MultiSelectWithCheckList
			options={options}
			onChange={onChange}
			value={value}
			placeholder={placeholder}
			portal={portal}
		/>
	);
};

export default InsuranceCompaniesMultiSelectWithCheckList;
